import {RELEASE_UNEP} from "../../../../enums/Profile/profile";

export const releaseUnepAction = (data) => {
    return {
        type:RELEASE_UNEP,
        payload:data,
    };
};
